export const AdminLogModuleType = {
	none: 0,
	load_doc: 1,
	unload_doc: 2,
	rank: 3,
	expo_push: 4,
	crud: 5,
	doc_parse: 6,
	tidsbanken_request: 7,
}